import React, { PureComponent } from 'react'

import { Button } from 'components'

import { createSlug } from 'utils/common'

import './tableOfContents.scss'

const renderChildren = children => (
	<ol>
		{children.map(child => (
			<li key={child.key}>
				<Button
					to={`#${createSlug(child.text)}`}
					text={child.text}
					layout="underlined-text"
				/>
			</li>
		))}
	</ol>
)

const renderItem = item => (
	<li key={item.key}>
		<Button
			to={`#${createSlug(item.text)}`}
			text={item.text}
			layout="underlined-text"
		/>
		{item.children.length ? renderChildren(item.children) : null}
	</li>
)

class TableOfContents extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const { editor, attributes } = this.props

		const { nodes } = editor.value.document
		const arr = []

		let lastParent = null
		let reachedOwnPosition = false

		nodes.forEach(node => {
			if (node.key === this.props.node.key) {
				reachedOwnPosition = true
			}

			if (!reachedOwnPosition) return
			if (
				(node.type !== 'heading-two' &&
					node.type !== 'heading-three') ||
				!node.text.length
			)
				return

			const n = {
				key: node.key,
				type: node.type,
				text: node.text,
				children: [],
			}

			if (lastParent && node.type === 'heading-three') {
				arr[arr.length - 1].children.push(n)
			} else {
				arr.push(n)
			}

			if (node.type === 'heading-two') lastParent = node.key
		})

		return (
			<div {...attributes} className={`c-toc ${attributes.className}`}>
				{!arr.length ? (
					<i>
						Please add some headlines below this element to get this
						table of contents filled.
					</i>
				) : (
					<ol>{arr.map(renderItem)}</ol>
				)}
			</div>
		)
	}
}

export default TableOfContents
